import { render } from "./RecruitmentStatus.vue?vue&type=template&id=b9dcb6be&scoped=true"
import script from "./RecruitmentStatus.vue?vue&type=script&lang=js"
export * from "./RecruitmentStatus.vue?vue&type=script&lang=js"

import "./RecruitmentStatus.vue?vue&type=style&index=0&id=b9dcb6be&lang=scss&scoped=true"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9dcb6be"]])

export default __exports__